module.exports = __webpack_public_path__ + "static/img/ic-refunded.96cc9666.png";